import { Link } from "react-router-dom";
import logo from "../assets/logo.jpg";

export default function Header() {
  return (
    <header className="site-header" data-testid="site-header">
      <div className="container header-inner">
        <a href="#top" className="brand" data-testid="header-brand">
          <img src={logo} alt="Logo LleGO" className="brand-logo" />
          <span className="brand-name">LleGO</span>
        </a>
        <nav className="nav-links" aria-label="Navegación principal">
          <a href="#funciones" data-testid="nav-link-funciones">Funciones</a>
          <a href="#como-funciona" data-testid="nav-link-como-funciona">Cómo funciona</a>
          <a href="#uruguay" data-testid="nav-link-uruguay">Uruguay</a>
        </nav>
        <Link to="/app" className="btn-download" data-testid="header-download-btn">
          Descargar
        </Link>
      </div>
    </header>
  );
}
